import React from 'react';
import { useData } from '../context/DataContext';
import { Trash2 } from 'lucide-react';
import { CourseForm } from './CourseForm';
import { SettingsForm } from './SettingsForm';
import type { Course } from '../types/course';

export function AdminPanel() {
  const { settings, updateSettings, courses, updateCourse, addCourse, deleteCourse, updateCoursePosition } = useData();

  const handleNewCourse = () => {
    const newCourse: Course = {
      id: `${Date.now()}`, // ID simple et unique
      titre: 'Nouvelle formation',
      description: 'Description de la formation',
      image: 'https://images.unsplash.com/photo-1610563166150-b34df4f3bcd6?auto=format&fit=crop&q=80&w=1200',
      categories: [],
      duree: '0 heures',
      niveau: 'Débutant',
      prix: 0,
      lien: '#',
      tags: [],
      rating: 5,
      order: courses.length + 1,
      hasVideo: false,
      hasLiveClasses: false
    };
    addCourse(newCourse);
  };

  const handleDeleteCourse = async (courseId: string) => {
    try {
      const confirmed = window.confirm('Êtes-vous sûr de vouloir supprimer cette formation ?');
      if (confirmed) {
        await deleteCourse(courseId);
      }
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      alert('Une erreur est survenue lors de la suppression du cours');
    }
  };

  // Tri simple des cours
  const sortedCourses = [...courses].sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-6">Administration</h2>
      
      <SettingsForm settings={settings} onUpdate={updateSettings} />
      
      <div className="mt-8">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Cours</h3>
          <button onClick={handleNewCourse} className="btn">
            Ajouter une formation
          </button>
        </div>

        <div className="space-y-6">
          {sortedCourses.map((course) => (
            <div key={course.id} className="p-6 border rounded-lg bg-gray-50 relative group">
              <div className="flex items-center gap-4 mb-4">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-gray-500">Position:</span>
                  <input
                    type="number"
                    value={course.order || 0}
                    onChange={(e) => {
                      const newPosition = parseInt(e.target.value);
                      if (!isNaN(newPosition) && newPosition > 0) {
                        updateCoursePosition(course.id, newPosition);
                      }
                    }}
                    className="w-20 p-1 border rounded text-center"
                    min="1"
                  />
                </div>
                <h4 className="text-lg font-medium">Formation #{course.order || 0}</h4>
                <button
                  onClick={() => handleDeleteCourse(course.id)}
                  className="absolute top-4 right-4 p-2 text-red-500 hover:text-red-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                >
                  <Trash2 size={20} />
                </button>
              </div>

              <CourseForm course={course} onUpdate={updateCourse} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}